import type { HumanMessage, Message } from '@/features/AIChat/types/chat';

export default function isHumanMessage(message: Message | undefined): message is HumanMessage {
  return message?.sender === 'human';
}
